import { createPage, Slot, Container, If } from 'react-commons';
import Meta from '@/components/Meta';

import { ArticlePageProps, fetchArticlePageProps } from '@/lib/util/fetchArticle';
import ArticleContent from '@/components/ArticleContent';
import DailyHorizontalNav from '@/components/DailyHorizontalNav';
import FluidLayout from '@/layouts/FluidLayout';
import helpAsideMenu from '@/lib/data/helpAsideMenu.json';
import AppHeader from '@/components/AppHeader';
import { useThemeStore } from '@/lib/stores/theme';


export default createPage<ArticlePageProps>('HelpPage', {}, function HelpPage ({ className }, props) {
  const metaTitle = 
    props.article.title +
    ' | Shockwave Help & Frequently Asked Questions' + 
    ' | Shockwave Games';

  const [ themeState ] = useThemeStore();
  const isClassic = themeState.layout === 'classic';

  return (
    <FluidLayout className={className}>
    
      {/* Meta information */}
      <Meta 
        title={metaTitle}
        titleTag={metaTitle}
      />

      {
        If(isClassic, () => (
          <Slot name='appHeader'>
            <AppHeader />
          </Slot>
        )).EndIf()
      }
    
      <Container>
    
        <DailyHorizontalNav links={helpAsideMenu} isClassic />
    
        <ArticleContent html={props.article.body} />
    
      </Container>
    
    </FluidLayout>
  );
});

export async function getStaticProps () {
  try {
    return {
      props: await fetchArticlePageProps('help'),
      revalidate: process.env.APP_CONFIG.REVALIDATE_INTERVAL_SHORT,
    };
  } catch (error) {
    throw error;
  }
}
